import { Context, propagation } from '@opentelemetry/api';
import { ReadableSpan, Span, SpanProcessor } from '@opentelemetry/sdk-trace-base';
import { mapBaggageKeyToVgAttribute } from './baggage-mapping';

/**
 * Span processor that adds baggage values as span attributes for searchability in Splunk/Honeycomb.
 */
export class BaggageSpanProcessor implements SpanProcessor {

  /**
   * Extracts all baggage values from current context and adds them as span attributes.
   *
   * This processor runs automatically for ALL spans created by OpenTelemetry instrumentation.
   * It ensures baggage values (client POID, referer, call chain) are searchable in observability tools.
   */
  onStart(span: Span, parentContext: Context): void {
    let baggage = propagation.getBaggage(parentContext);

    // Fallback to window context if baggage not in parent context
    // Needed when context is lost across async boundaries in Angular
    if (!baggage && (window as any).__OTEL_BAGGAGE_CONTEXT__) {
      baggage = propagation.getBaggage((window as any).__OTEL_BAGGAGE_CONTEXT__);
    }

    if (!baggage) {
      return;
    }

    // Add each baggage entry as a span attribute using shared mapping
    baggage.getAllEntries().forEach(([key, entry]) => {
      const attributeName = mapBaggageKeyToVgAttribute(key);
      span.setAttribute(attributeName, entry.value);
    });
  }

  onEnd(_span: ReadableSpan): void {
    // No-op: We only need onStart to add baggage attributes
  }

  shutdown(): Promise<void> {
    return Promise.resolve();
  }

  forceFlush(): Promise<void> {
    return Promise.resolve();
  }
}
